
/**
 * Regular animation time.
 */

const regularAnimationTime = 500;

/**
 * Fast animation time.
 */

const fastAnimationTime = 200;

/**
 * Animation durations.
 */

const duration = {
  fast: `${fastAnimationTime}ms`,
  regular: `${regularAnimationTime}ms`
};

/**
 * Bezier.
 */

const bezier = {
  easeInOutQuad: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeInOutQuart: 'cubic-bezier(0.770, 0, 0.175, 1)'
};

/**
 * Default transition.
 */

const defaultTransition = `${duration.regular} ease`;

/**
 * Fast transition.
 */

const fastTransition = `${duration.fast} ease`;

/**
 * Quart transition.
 */

const quartTransition = `${duration.regular} ${bezier.easeInOutQuart}`;

/**
 * Export `animations`.
 */

export const animations = {
  bezier,
  defaultTransition,
  fastTransition,
  quartTransition
};
